import React from 'react';
import {
    Box,
    Grid,
    IconButton,
    TextField,
    Tooltip
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useStudio } from '../../Context/StudioContext';
import { restrictNegativeInput, handlePositiveNumberChange } from '../../utils/numberInputHelpers';

const ContactDetails = () => {
    const { formData, setFormData } = useStudio();

    const handleSlotChange = (index, field, value) => {
        // Ensure numeric fields accept only positive numbers
        if (['contactPhoneNum'].includes(field)) {
            // Allow empty string so user can clear input, and block negatives
            if (value === '' || (/^\d+$/.test(value) && Number(value) >= 0)) {
                updateSlotField(index, field, value);
            }
        } else {
            updateSlotField(index, field, value);
        }
    };

    const updateSlotField = (index, field, value) => {
        const updated = [...(formData.contactDetails || [])];
        updated[index][field] = value;
        setFormData(prev => ({ ...prev, contactDetails: updated }));
    };

    const addSlot = () => {
        setFormData(prev => ({
            ...prev,
            contactDetails: [...(prev.contactDetails || []), { slotTimeStart: '', label: '' }]
        }));
    };

    const removeSlot = (index) => {
        const updated = [...(formData.contactDetails || [])];
        updated.splice(index, 1);
        setFormData(prev => ({ ...prev, contactDetails: updated }));
    };


    return (
        <Box sx={{ width: '100%', mt: 1 }}>
            {(formData.contactDetails || []).map((slot, index) => (
                <Grid
                    container
                    bgcolor={''}
                    key={index}
                    display={'block'}

                    alignItems="center"
                    sx={{ mb: 3 }}
                >

                    <Grid display={'flex'} gap={2} mt={2}>
                        <Grid >
                            <TextField
                                fullWidth
                                label="Nama"
                                value={slot.contactName || ''}
                                onChange={(e) => handleSlotChange(index, 'contactName', e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid>
                            <TextField
                                fullWidth
                                label="Hubungan"
                                value={slot.relationship || ''}
                                onChange={(e) => handleSlotChange(index, 'relationship', e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>


                        <Grid >
                            <TextField
                                fullWidth
                                label="No Telefon"
                                type="number"
                                value={slot.contactPhoneNum || ''}
                                onChange={(e) => handleSlotChange(index, 'contactPhoneNum', e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    sx: {
                                        '& input[type=number]': {
                                            MozAppearance: 'textfield',
                                        },
                                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                    },
                                }}
                            />
                        </Grid>

                    </Grid>


                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        mt={1}
                        sx={{ width: '100%' }}
                    >
                        <Tooltip title={"Remove slot"}>
                            <IconButton
                                onClick={() => removeSlot(index)}
                                size="small"
                                sx={{ color: '#d32f2f' }}
                                disabled={formData.contactDetails.length === 1}
                            >
                                <RemoveCircleOutlineIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Add slot">
                            <IconButton
                                size="small"
                                onClick={addSlot}
                                color="primary"
                                disabled={formData.contactDetails.length === 5}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>

                </Grid>


            ))}

        </Box>
    );
};

export default ContactDetails;
